"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BICtoBankInfo = void 0;
const bankCodes_1 = require("../constants/bankCodes");
/**
 * An object containing the country code and the name of the bank
 * @typedef {Object} BankInfo
 * @property {string} countryCode - The country code of the bank
 * @property {string} name - The name of the bank if known
 */
/**
 * Retrieve bank name and country code from the bic
 * @param {string} BIC - The bic
 * @returns {BankInfo} - The bank information retrieved from the bank bic
 */
const BICtoBankInfo = (BIC) => {
    // We're going to use bankCode as index to access a value in BANK_CODES like this "BANK_CODES[bankCode]".
    // BANK_CODES keys are static although bankCode is a dynamically computed value, so it cannot be used as-is
    // to index BANK_CODES, so we have to typecast it to "keyof typeof BANK_CODES" to allow that behaviour. We are
    // safe to do so because we check the existence of BANK_CODES[bankCode] before using that value.
    const bankCode = BIC.substring(0, 4);
    const countryCode = BIC.substring(4, 6);
    return bankCodes_1.BANK_CODES[bankCode]
        ? { ...bankCodes_1.BANK_CODES[bankCode], countryCode }
        : { countryCode, name: '' };
};
exports.BICtoBankInfo = BICtoBankInfo;
